<template>
  <div :class="bem({ direction })">
    <FrameTypeOption
      v-for="(option, index) in props.options"
      :key="index"
      :view="view"
      :option="option"
      :active-option="props?.activeOption"
      :customised-product="customisedProduct"
      @selected="emits('selected', option)"
    />
  </div>
</template>

<script setup lang="ts">
interface Props {
  options: Array<any>
  activeOption?: object
  view: 'compact' | 'full',
  customisedProduct: any
}

const props = withDefaults(defineProps<Props>(), {
  options: () => [],
  activeOption: () => ({}),
  view: 'compact',
})

const emits = defineEmits(['selected'])

const bem = useBEM('FrameTypeOptions')

const direction = computed(() => {
  return props.view === 'compact' ? 'row' : 'column'
})
</script>

<style lang="postcss" scoped>
.FrameTypeOptions {
  @apply grid grid-cols-3 gap-2;
}

.FrameTypeOptions--direction-column {
  @apply grid-cols-1 gap-3;
}
</style>
